import { cn } from '@/utils/cn';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

export function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <div className="min-h-screen bg-surface-base flex items-center justify-center p-4">
      <div
        role="alert"
        className={cn(
          'w-full max-w-md p-6 sm:p-8 text-center rounded-xl',
          'bg-surface-elevated',
          'border border-border-default'
        )}
      >
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-error/10 mb-4">
          <AlertTriangle className="w-6 h-6 text-error" />
        </div>

        <h2 className="text-heading-small font-medium mb-2 text-foreground-primary">
          Something went wrong
        </h2>

        <p className="text-body-medium text-foreground-secondary mb-4">
          An unexpected error occurred. Please try again.
        </p>

        <pre
          className={cn(
            'mb-6 p-4 rounded-lg overflow-auto text-left',
            'bg-error/10',
            'text-error text-body-small',
            'max-h-32'
          )}
        >
          {error.message}
        </pre>

        <Button
          onClick={resetErrorBoundary}
          variant="primary"
          size="lg"
          fullWidth
          className="rounded-lg"
        >
          Try again
        </Button>
      </div>
    </div>
  );
}
